import React from 'react';

export const SearchOutlineIcon = ({
  color = '#2D264B',
  w = '24',
  h = '24',
}: {
  color?: string;
  w?: string;
  h?: string;
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1819_4344)">
        <path d="M9.33512 4.80232C9.74423 4.73752 10.0234 4.35334 9.95856 3.94423C9.89376 3.53511 9.50958 3.25599 9.10047 3.32079C6.64008 3.71047 4.71044 5.64012 4.32076 8.1005C4.25596 8.50961 4.53508 8.89379 4.9442 8.95859C5.35331 9.02339 5.73749 8.74426 5.80229 8.33515C6.09032 6.51661 7.51658 5.09035 9.33512 4.80232Z" fill={color} />
        <path fillRule="evenodd" clipRule="evenodd" d="M11 0.25C5.61522 0.25 1.25 4.61522 1.25 10C1.25 15.3848 5.61522 19.75 11 19.75C16.3848 19.75 20.75 15.3848 20.75 10C20.75 4.61522 16.3848 0.25 11 0.25ZM2.75 10C2.75 5.44365 6.44365 1.75 11 1.75C15.5563 1.75 19.25 5.44365 19.25 10C19.25 14.5563 15.5563 18.25 11 18.25C6.44365 18.25 2.75 14.5563 2.75 10Z" fill={color} />
        <path d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L19.5304 17.4698Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1819_4344">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const SearchFilledIcon = ({
  color = '#2D264B',
  w = '24',
  h = '24',
}: {
  color?: string;
  w?: string;
  h?: string;
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1892_12898)">
        <path fillRule="evenodd" clipRule="evenodd" d="M2 10C2 5.02944 6.02944 1 11 1C15.9706 1 20 5.02944 20 10C20 14.9706 15.9706 19 11 19C6.02944 19 2 14.9706 2 10ZM9.95856 3.9442C10.0234 4.35331 9.74423 4.73749 9.33512 4.80229C7.51658 5.09032 6.09032 6.51658 5.80229 8.33512C5.73749 8.74423 5.35331 9.02336 4.9442 8.95856C4.53508 8.89376 4.25596 8.50958 4.32076 8.10047C4.71044 5.64008 6.64008 3.71044 9.10047 3.32076C9.50958 3.25596 9.89376 3.53508 9.95856 3.9442Z" fill="#ED3237" />
        <path d="M18.4697 17.4697C18.7626 17.1768 19.2374 17.1768 19.5303 17.4697L23.5302 21.4696C23.8231 21.7625 23.8231 22.2374 23.5302 22.5303C23.2373 22.8232 22.7625 22.8232 22.4696 22.5303L18.4697 18.5303C18.1768 18.2374 18.1768 17.7626 18.4697 17.4697Z" fill="#ED3237" />
      </g>
      <defs>
        <clipPath id="clip0_1892_12898">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
};

